import { createAsyncThunk } from '@reduxjs/toolkit';
import ScoreGroupsService from 'business/services/PlateService';
import WellService from 'business/services/WellService';
import {
  BasePropertyDTO,
  CaptureProfileDTO,
  ChartDTO,
  ScoreDefinitionDTO,
  ScoresGroupsDTO,
} from 'business/models/Models';
import { GlobalPreferencesService } from 'business/services/GlobalPreferencesService';
import { CanvasPreferences } from 'redux/reducers/commonReducer';
import { Preference } from 'components/main/GlobalPrefrences/constants';
import SearchnFilterService from 'business/services/searchnFilterService';

export const scoreGroupDetailsThunk = createAsyncThunk<
  {
    scoreGroupData: ScoresGroupsDTO[];
    ScoreData: { [groupId: number]: ScoreDefinitionDTO[] };
  },
  void
>('searchGroupDetailsThunk', async (_, thunkApi) => {
  try {
    const scoreGroupsService = new ScoreGroupsService();
    const wellService = new WellService();

    const groupPromise = scoreGroupsService
      .getScoreGroupsService(false, true)
      .then((groupData) => {
        if (groupData === null) {
          return null;
        }
        return groupData.filter((sg) => sg.name !== 'Interesting');
      });

    const scorePromise = wellService.getWellDropScores();

    const [groupData, scoreData] = await Promise.all([groupPromise, scorePromise]);

    if (groupData === null || scoreData === null) {
      return null;
    }

    const scoreGroupedByGroupId: { [groupId: number]: ScoreDefinitionDTO[] } =
      scoreData.reduce((acc, curr) => {
        const groupId = curr.wellDropScoreGroupId;
        if (!acc[groupId]) {
          acc[groupId] = [];
        }
        acc[groupId].push(curr);
        return acc;
      }, {});

    return { scoreGroupData: groupData, ScoreData: scoreGroupedByGroupId };
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
});

export const canvasPreferenceThunk = createAsyncThunk<CanvasPreferences, string[]>(
  'canvasPreferenceThunk',
  async (propertyKeys, thunkApi) => {
    try {
      const gpService = new GlobalPreferencesService();
      const result = await gpService.getProperties(propertyKeys);
      const canvasPreferences = result.reduce((acc, propertyData) => {
        acc[propertyData.name] = (propertyData as any).value;
        return acc;
      }, {});

      return canvasPreferences as CanvasPreferences;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  },
);

export const allImagingSettingsThunk = createAsyncThunk<CaptureProfileDTO, void>(
  'allImagingSettingsThunk',
  async (_, thunkApi) => {
    try {
      const captureProfileService = new ScoreGroupsService();
      return (await captureProfileService.getCaptureProfiles()).toJSON();
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  },
);

export const userPreferencesThunk = createAsyncThunk<BasePropertyDTO[], void>(
  'userPreferencesThunk',
  async (_, thunkApi) => {
    try {
      const gpService: GlobalPreferencesService = new GlobalPreferencesService();
      return await gpService.getAllPropNames(Preference.UserPreference);
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  },
);

export const searchTargetChartsThunk = createAsyncThunk<
  { [key: number]: ChartDTO[] },
  void
>('searchTargetChartsThunk', async (_, thunkApi) => {
  try {
    const dataService = new SearchnFilterService();
    return await dataService.getSearchTargetCharts();
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
});
